export const EggType = {
  BETA: 'BETA',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
}